import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BaseObject } from '../shared/baseClass';
import { RegistryService } from '../registry/registry.service';
import { AuthService, User } from '../user/auth.service';
import { Settings } from './settings';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Website } from '../website-builder/wedding';

export interface State {
  settings: Settings;
}

@Injectable()
export class SettingsStateStore {

  user: User;
  settings: Settings;
  addSettings(settings: Settings, settingsDocId: string) {
    const settingsObj = { ...settings };
    this.firestore
      .collection(this.WEBSITES_SETTINGS_COLLECTION_NAME)
      .doc(settingsDocId)
      .set(settingsObj);
  }

  updateSettings(settings: Settings) {
    this.firestore
      .collection(this.WEBSITES_SETTINGS_COLLECTION_NAME)
      .doc(settings.id)
      .update(settings);
  }

  private state$: BehaviorSubject<State>;
  
  WEBSITES_SETTINGS_COLLECTION_NAME = 'settings';
  userId: string;

  constructor(
    private firestore: AngularFirestore,
    private _authService: AuthService,
    private registryService: RegistryService,
    private afs: AngularFirestore,
    private _http: Http,
    ) {
    this.state$ = new BehaviorSubject<State>({
        settings: null
    });

    this._authService.user.subscribe(user => {
      if (user) {
        this.userId = user.uid;
        this.user = user;
        return this.afs
        .collection<Settings>(this.WEBSITES_SETTINGS_COLLECTION_NAME, ref =>
          ref.where('userId', '==', this.userId)
        )
          .snapshotChanges()
          .subscribe(x => {
            if (x && x.length > 0 && x[0].payload) {
              const settings = x[0].payload.doc.data() as Settings;
              settings.id = x[0].payload.doc.id;                
              
              if(settings.registryEnabled == null || settings.registryEnabled == undefined){
                settings.registryEnabled = true;
              }

              const newState: State = {
                settings: settings,
              };
              this.settings = settings;
              this.updateState(newState);
            } else {
              // No document for this user, create a new Website
            }
          });
      }
    });
  }

  getSettingsViaUserId(userId: string): Observable<Settings> {
    return this.afs
      .collection<Settings>(this.WEBSITES_SETTINGS_COLLECTION_NAME, ref =>
        ref.where('userId', '==', userId)
      )
      .snapshotChanges()
      .map(x => {
        if (x && x.length > 0 && x[0].payload) {
          const settings = x[0].payload.doc.data() as Settings;
          settings.id = x[0].payload.doc.id;
          this.settings = settings;

          const newState: State = {
            settings: settings,
          };
          this.updateState(newState);
          return settings;
        }
      });
  }

  translate(){
    return;
  }

  getState(): Observable<State> {
    return this.state$.asObservable();
  }

  updateState(newState: State) {
    this.state$.next(newState);
  }
}


// WEBPACK FOOTER //
// ./src/app/settings/settings.state.store.ts